import React from 'react';
import ContentLoader from 'react-content-loader';
import { GRID } from './settings';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROWS = 8;
const COL_WIDTH = GRID.colWidth;
const ROW_HEIGHT = GRID.rowHeight;

const SpreadsheetLoader = () => /*#__PURE__*/_jsx("div", {
  className: styles.container,
  children: /*#__PURE__*/_jsxs(ContentLoader, {
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      rx: "3",
      ry: "3",
      width: COL_WIDTH,
      height: ROW_HEIGHT
    }), /*#__PURE__*/_jsx("rect", {
      x: COL_WIDTH + 4,
      y: "0",
      rx: "3",
      ry: "3",
      width: COL_WIDTH,
      height: ROW_HEIGHT
    }), /*#__PURE__*/_jsx("rect", {
      x: (COL_WIDTH + 4) * 2,
      y: "0",
      rx: "3",
      ry: "3",
      width: COL_WIDTH,
      height: ROW_HEIGHT
    }), /*#__PURE__*/_jsx("rect", {
      x: (COL_WIDTH + 4) * 3,
      y: "0",
      rx: "3",
      ry: "3",
      width: COL_WIDTH,
      height: ROW_HEIGHT
    }), Array.from({
      length: ROWS
    }, (_, index) => /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx("rect", {
        x: 0,
        y: (index + 1) * ROW_HEIGHT + (index + 1) * 8,
        rx: "3",
        ry: "3",
        width: COL_WIDTH,
        height: ROW_HEIGHT
      }), /*#__PURE__*/_jsx("rect", {
        x: COL_WIDTH + 4,
        y: (index + 1) * ROW_HEIGHT + (index + 1) * 8,
        rx: "3",
        ry: "3",
        width: COL_WIDTH,
        height: ROW_HEIGHT
      }), /*#__PURE__*/_jsx("rect", {
        x: (COL_WIDTH + 4) * 2,
        y: (index + 1) * ROW_HEIGHT + (index + 1) * 8,
        rx: "3",
        ry: "3",
        width: COL_WIDTH,
        height: ROW_HEIGHT
      }), /*#__PURE__*/_jsx("rect", {
        x: (COL_WIDTH + 4) * 3,
        y: (index + 1) * ROW_HEIGHT + (index + 1) * 8,
        rx: "3",
        ry: "3",
        width: COL_WIDTH,
        height: ROW_HEIGHT
      }), /*#__PURE__*/_jsx("rect", {
        x: (COL_WIDTH + 4) * 4,
        y: (index + 1) * ROW_HEIGHT + (index + 1) * 8,
        rx: "3",
        ry: "3",
        width: COL_WIDTH,
        height: ROW_HEIGHT
      })]
    }, index))]
  })
});

export default SpreadsheetLoader;